<template>
  <v-dialog v-model="newStateDialog" persistent max-width="600">
    <v-card>
      <v-card-title>
        <h2>NUEVO ESTADO</h2>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-select
            v-model="selectedState"
            :items="allStates"
            item-text="label"
            return-object
            label="Estado"
            color="#0099E1"
          ></v-select>
          <v-container
            class="general-container"
            v-if="selectedState.value === STATES.IRRIGATING"
          >
            <v-text-field label="Lamina Seteada" type="number" step="any" hint="0.00 mm"
              v-model="sheet"
            >
            </v-text-field>

            <v-container
              class="general-container-calculator"
            >
              <v-text-field label="Presión" type="number" step="any" hint="0.00 bar"
                v-model="pressure"
              >
              </v-text-field>
              <v-select
                class="pressure-selector"
                v-model="selectedPressureType"
                :items="['BAR', 'PSI']"
                @change="calculatePressure"
              ></v-select>
            </v-container>
            <div class="calculator-input">
              
            </div>
          </v-container>
          <v-select
            v-if="selectedState.value === STATES.FAILURE"
            v-model="selectedFailureType"
            item-text="label"
            item-value="id"
            :items="allFailTypes"
            label="Tipo"
          ></v-select>

          <v-container
            class="general-container"
            v-if="selectedState"
          >
            <v-select
              v-if="showOrientation"
              v-model="direction"
              :items="orientations"
              item-text="text"
              item-value="value"
              label="Sentido de giro"
            />
            <v-select
              v-model="selectedPosition"
              :items="positionStates"
              item-text="text"
              item-value="value"
              label="Posición"
              @change="checkSelection()"
            />
            <v-container
              class="position-container"
              v-if="showAngle"
            >
              <div class="align-center"><b>0°</b></div>
              <div class="angle-picker">
                <v-progress-circular
                  :rotate="angle"
                  :size="100"
                  :value="3"
                  :width="6"
                  color="light-blue"
                >
                  <v-text-field
                    suffix="°"
                    v-model="angle"
                  ></v-text-field>
                </v-progress-circular>
              </div>
              <div class="general-container-calculator">
                <div class="half-width-left"><b>0°</b></div>
                <div class="half-width-right"><b>360°</b></div>
              </div>
              <v-slider
                class="no-top-margin"
                v-model="angle"
                min="0"
                max="360"
                color="light-blue"
              ></v-slider>
            </v-container>
            <v-container
              v-if="showCoordinates"
            >
              <v-container
                class="centered-input"
              >
                <v-text-field
                  solo
                  v-model="coordinatesString"
                  readonly
                ></v-text-field>
              </v-container>
              <v-icon color="#0098E1">
                gps_fixed
              </v-icon>
              <v-btn
                @click="accessLocation()"
              >Tomar mi posición de GPS</v-btn>
            </v-container>
          </v-container>
          <v-container
            class="date-time-flex"
          >
            <div class="date-time-selectors">
              <v-icon color="#0098E1">
                access_time
              </v-icon>
              <datetime type="time" v-model="timeString" format="hh:mm a" use12-hour class="theme-ponce"></datetime> 
            </div>
            <div class="date-time-selectors">
              <v-icon color="#0098E1">
                event
              </v-icon>
              <datetime type="date" value-zone="local" v-model="dateString" format="dd/MM/yyyy" class="theme-ponce"></datetime>
            </div>
          </v-container>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancel()">Cancelar</v-btn>
        <v-btn color="primary" text @click="onSave()">Actualizar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { Plugins } from '@capacitor/core';
  const { Geolocation } = Plugins;

  import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue';
  import {
    ALL_STATES_QUERY,
    ALL_FAILTYPES_QUERY
  } from '../../../../constants/graphql';
  import _orderBy from 'lodash/orderBy';
  import { STATES } from '../../../../constants/constants';
  import _get from 'lodash/get';
  
  export default {
    data () {
      return {
        positionStates: [
          { text: 'Tomar posición manual', value: 'manual' },
          { text: 'Tomar posición por GPS', value: 'automatic' }
        ],
        allFailTypes: [],
        allStates: [],
        selectedPressureType: 'BAR',
        orientations: [
          { text: 'Horario', value: 'F' },
          { text: 'Antihorario', value: 'R' }
        ],
        selectedState: {},
        selectedPosition: '',
        selectedFailureType: '',
        date: new Date(),
        angle: '',
        direction: 'F',
        eventName: '',
        eventNotes: '',
        dateString: '',
        timeString: '',
        coordinates: '',
        coordinatesString: '',
        sheet: '',
        pressure: '',
        menu2: false,
        showCoordinates: false,
        showAngle: false,
        STATES
      };
    },
    computed: {
      deviceCenter () {
        return {
          latitude: this.device.Location.latitude,
          longitude: this.device.Location.longitude
        };
      },
      lastEventDate () {
        if (this.device.Event) {
          return new Date(this.device.Event.dateTime);
        } else {
          return null;
        }
      },
      showOrientation () {
        if (this.selectedState.value === STATES.FAILURE) {
          return !this.device.Event;
        } else return this.selectedState.value === STATES.IRRIGATING || this.selectedState.value === STATES.MOVING;
      },
      showPositionSelect () {
        return !this.selectedState && this.selectedPosition === '';
      }
    },
    mounted () {
      this.timeString = this.date.toISOString();
      this.dateString = this.date.toISOString();
    },
    props: {
      newStateDialog: {
        type: Boolean,
        default: false
      },
      deviceId: {
        type: String
      },
      device: {
        type: Object
      }
    },
    apollo: {
      allStates: {
        query: ALL_STATES_QUERY,
        result ({data}) {
          this.allStates = _orderBy(data.allStates, ['label']);
        }
      },
      allFailTypes: {
        query: ALL_FAILTYPES_QUERY
      }
    },
    methods: {
      onSave () {
        switch (this.selectedState.value) {
          case STATES.IRRIGATING:
            this.selectedFailureType = '';
            break;
          case STATES.FAILURE:
            this.pressure = '';
            this.sheet = '';
            break;
          default:
            this.selectedFailureType = '';
            this.pressure = '';
            this.sheet = '';
        };
        const newDate = this.dateString.split('T')[0];
        const newTime = this.timeString.split('T')[1];
        this.date = new Date(`${newDate}T${newTime}`);

        const {eventName, eventNotes, date, sheet, selectedState, selectedFailureType, coordinates, direction} = this.$data;
        const lat = _get(coordinates, 'lat', 0);
        const lng = _get(coordinates, 'lng', 0);

        if (this.showCoordinates) {
          this.angle = this.bearing(this.deviceCenter.latitude, this.deviceCenter.longitude, this.coordinates.lat, this.coordinates.lng);
        };

        if (this.selectedPressureType === 'PSI') {
          this.pressure = parseFloat((this.pressure * 0.06894760).toFixed(2));
        }

        const {angle, pressure} = this.$data;

        const variables = {
          name: eventName,
          dateTime: date.toISOString(),
          sheet: sheet !== '' ? parseFloat(sheet) : null,
          angle: angle !== '' ? parseInt(angle) : null,
          notes: eventNotes,
          direction,
          pressure: pressure !== '' ? parseFloat(pressure) : null,
          latitude: lat,
          longitude: lng,
          stateId: selectedState.id,
          deviceId: parseInt(this.deviceId)
        };
        let lastEventDate = this.lastEventDate ? this.lastEventDate.getTime() : null;
        let auxObj = {
          selectedFailureType: selectedFailureType,
          lastEventDate: lastEventDate,
          eventDate: date.getTime(),
          deviceId: this.deviceId
        };
        this.$store.dispatch('uploadCommonEvent', {
          variables: variables,
          auxObj: auxObj,
          comesFromStore: false,
          key: null
        });
        this.resetData();
        if (window.navigator.onLine) {
          setTimeout(() => {
            this.$emit('update-device');
          }, 1500);
        }
        this.$emit('update:newStateDialog', false);
      },
      resetData () {
        this.selectedState = {};
        this.selectedFailureType = '';
        this.pressure = '';
        this.sheet = '';
        this.direction = 'F';
        this.selectedPressureType = 'BAR';
        this.selectedPosition = '';
        this.coordinates = {};
        this.angle = '';
        this.showAngle = this.showCoordinates = false;
      },
      checkSelection () {
        if (this.selectedPosition === 'automatic') {
          this.accessLocation();
          this.angle = '';
          this.showAngle = false;
          this.showCoordinates = true;
        } else {
          this.angle = 0;
          this.coordinates = {};
          this.showCoordinates = false;
          this.showAngle = true;
        };
      },
      async accessLocation () {
        const coordinates = await Geolocation.getCurrentPosition();
        this.coordinatesString = `${coordinates.coords.latitude},${coordinates.coords.longitude}`;
        this.coordinates = {
          lat: coordinates.coords.latitude,
          lng: coordinates.coords.longitude
        };
      },
      onCancel () {
        this.$emit('update-device');
        this.$emit('update:newStateDialog', false);
        this.resetData();
      },
      // Converts from degrees to radians.
      toRadians (degrees) {
        return degrees * Math.PI / 180;
      },
      // Converts from radians to degrees.
      toDegrees (radians) {
        return radians * 180 / Math.PI;
      },
      bearing (startLat, startLng, destLat, destLng) {
        startLat = this.toRadians(startLat);
        startLng = this.toRadians(startLng);
        destLat = this.toRadians(destLat);
        destLng = this.toRadians(destLng);

        let y = Math.sin(destLng - startLng) * Math.cos(destLat);
        let x = Math.cos(startLat) * Math.sin(destLat) -
              Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
        let brng = Math.atan2(y, x);
        brng = this.toDegrees(brng);
        return (brng + 360) % 360;
      },
      calculatePressure () {
        switch (this.selectedPressureType) {
          case 'BAR':
            this.pressure = parseFloat((this.pressure * 0.06894760).toFixed(2));
            break;
          case 'PSI':
            this.pressure = parseFloat((this.pressure * 14.50376808).toFixed(2));
            break;
        };
      }
    },
    watch: {
      newStateDialog: function (val) {
        this.date = new Date();
        this.timeString = this.date.toISOString();
        this.dateString = this.date.toISOString();
      }
    },
    components: {
      VueTimepicker
    }
  };
</script>



// WEBPACK FOOTER //
// NewStateModal.vue?684a5d16